<template>
    <el-dialog :visible.sync="boxVisible2" v-if="boxVisible2" class="ConnectWalletBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true" :show-close="false">
        <div class="dialog-body">
            <div class="message-content">{{message}}</div>
        </div>
    </el-dialog>
</template>

<script>
import bus from '@/assets/js/bus';
export default {
    name:"ConnectWalletBox",
    props:{
        boxVisible: Boolean,
    },
    data() {
        return {
            boxVisible2:this.boxVisible,
            message:"",
        };
    },
    methods:{
        show() {
            this.boxVisible2 = true;
            this.$nextTick(()=>{
                if(this.isMainnet()){
                    this.message = "请使用 Polygon Mainnet 主网登录";
                }else{
                    this.message = "请使用 ETH Sepolia Testnet 测试网登录";
                }
            })
        },
        close() {
            let _this = this;
            setTimeout(() => {
                _this.boxVisible2 = false;
                _this.message = "";
            }, 100);
        }
    }
}
</script>
<style lang="less">
.ConnectWalletBox {
    display:flex;
    background-color:rgba(0,0,0,0.9);
    position: fixed;
    top:0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    .el-dialog {
        width: 100%;
        background: transparent;
        margin: auto 10px!important;
    }
    .el-dialog__header{
        display:none;
    }
    .el-dialog__body{
        padding:0px;
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
    }
    .message-content{
        font-size: 25px;
        word-break: break-word;
        font-weight: bolder;
        color: #bdff00;
    }
}
</style>
